import EmptyView1 from '../../layouts/EmptyView1'
import CreateAccount from './CreateAccount'

export default EmptyView1(CreateAccount)



// WEBPACK FOOTER //
// ./src/pages/create-account/index.js